import { useMatchingSections } from '@/modules/restrictions/hooks/useAccessSections';
import { useGetCommonStore } from '@/store';

export const useCMSActiveTournaments = () => {
  const useCommonStore = useGetCommonStore();
  const activeTournaments = useCommonStore.use.activeTournaments();

  const filteredTournamentsGroups = useMatchingSections(activeTournaments);

  return {
    activeTournaments: filteredTournamentsGroups,
  };
};
